var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "row" },
      [
        _c(
          "b-tabs",
          { staticClass: "w-100", attrs: { small: "", card: "" } },
          [
            _vm._l(_vm.packs, function (pack, idx) {
              return [
                !_vm.isExpired(pack) && _vm.isDueDate(pack)
                  ? _c(
                      "b-tab",
                      {
                        staticClass: "pretty-scroll scroll-500",
                        attrs: {
                          active: idx === 0,
                          "no-body": "",
                          title: pack.name,
                        },
                      },
                      [
                        _c("pack-banner", {
                          attrs: { source: "store", pack: pack },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            }),
          ],
          2
        ),
      ],
      1
    ),
    _vm._v(" "),
    _vm._m(0),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c(
        "div",
        {
          staticClass: "col border-top pt-3 font-weight-bold mt-3 text-center",
        },
        [
          _vm._v("\n                ISSUES WITH YOUR PURCHASE? CONTACT US:"),
          _c("br"),
          _vm._v("\n                support@meowplayground.com\n            "),
        ]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }